import React, {useState} from "react";
import {Link} from "react-router-dom";
import enFlag from "../static/img/BritishFlag.png";
import ukrFlag from "../static/img/UkrainianFlag.png";

const Coordinator: React.FC = ()=> {
    const [isHovered, setIsHovered] = useState({on: false, index: 0});
    const [en, setEn] = useState(false);
    //const contentsEn = [];
    //const contentsUa = [];

    return (
        <div style={{marginTop:"30px"}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",marginBottom:"50px"}} >
                <Link to={"/"} className={"consortium_link"}
                      style={(isHovered.on && isHovered.index === 0) ? {color:"gray",boxShadow:"3px 3px 3px"} : {color:"white"}}
                      onMouseEnter={() => setIsHovered({on:true,index:0})}
                      onMouseLeave={() => setIsHovered({on:false,index:0})}
                >&#8592; Back</Link>
                <button className={"consortium_button"}
                        onClick={()=> setEn(!en)} >
                    {en ? <img src={ukrFlag} alt="flag"/> : <img src={enFlag} alt="flag"/>}
                </button>
            </div>
            <h1>
                {en ? "Coordinator" : "Координатор"}
            </h1>
            {en ? <p style={{fontWeight:"initial",fontSize:"22px",margin:"10px 150px 10px 50px",textAlign:"left"}} >
                <b>Maksymenko Nadiya </b>
                , Doctor of Geography, Professor, Head of the Department of Environmental Monitoring and Protected Areas Management of the Karazin Institute of Environmental Science.
            </p> : <p style={{fontWeight:"initial",fontSize:"22px",margin:"10px 150px 10px 50px",textAlign:"left"}} >
                <b>Максименко Н. В. </b>
                ,доктор географічних наук, професор, завідувачка кафедри екологічного моніторингу та заповідної справи Каразінського навчально-наукового інституту екології.
            </p>}
            <p style={{fontWeight:"initial",fontSize:"22px",margin:"10px 150px 10px 50px",textAlign:"left"}}>
                <b>email: </b>
                maksymenko@karazin.ua
            </p>

        </div>
    )
}
export default Coordinator;
